import { createIcon } from '@chakra-ui/icons'

const DOCIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#0CACFE"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        DOC
      </text>
      <path
        fill="#F2F2F4"
        d="M-5297.2 4776.7h41.1c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-41.1c-.7 0-1.3.6-1.3 1.3 0 .7.5 1.3 1.3 1.3z"
      />
      <path
        fill="#F2F2F4"
        d="M-5256.1 4795.8h-41.1c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3h41.1c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3z"
      />
      <path
        fill="#F2F2F4"
        d="M-5274.2 4806.6h-23.1c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3h23.1c.7 0 1.3-.6 1.3-1.3s-.5-1.3-1.3-1.3z"
      />
      <path
        fill="#F2F2F4"
        d="M-5297.2 4787.5h31.2c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-31.2c-.7 0-1.3.6-1.3 1.3 0 .8.5 1.3 1.3 1.3z"
      />
    </g>
  ),
})

export default DOCIcon
